import { render, staticRenderFns } from "./workplace.vue?vue&type=template&id=2776691c&scoped=true&"
import script from "./workplace.vue?vue&type=script&lang=js&"
export * from "./workplace.vue?vue&type=script&lang=js&"
import style0 from "./workplace.vue?vue&type=style&index=0&id=2776691c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2776691c",
  null
  
)

export default component.exports